const css = `._8S88Za__tooltip{background:#121212}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tooltip":"_8S88Za__tooltip"};
